import { render, staticRenderFns } from "./BranchAdmin.vue?vue&type=template&id=65f77812&scoped=true"
import script from "./BranchAdmin.vue?vue&type=script&lang=js"
export * from "./BranchAdmin.vue?vue&type=script&lang=js"
import style0 from "./BranchAdmin.vue?vue&type=style&index=0&id=65f77812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f77812",
  null
  
)

export default component.exports